import t from"./_getNative.js";var r=t,e=function(){try{var t=r(Object,"defineProperty");return t({},"",{}),t}catch(t){}}();export{e as default};
//# sourceMappingURL=_defineProperty.js.map
